import { Button, ButtonGroup, Box, Text } from '@chakra-ui/react';
import { ReactElement, useState } from 'react';
import { CalendlyInlineWidget, Modal } from 'shared-components';
import { useDispatch } from 'react-redux';
import { getApplicantOffer } from '@/store/apply/actions';

interface BookInterviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  applicantId: string;
  uni: string;
  offerId: string;
  utmKey: string;
  schedulingUrl: string | null;
}

export const BookInterviewModal = ({
  isOpen,
  onClose,
  applicantId,
  uni,
  offerId,
  utmKey,
  schedulingUrl,
}: BookInterviewModalProps): ReactElement => {
  const dispatch = useDispatch();
  const [bookingConfirmed, setBookingConfirmed] = useState(false);

  const handleEventScheduled = (): void => {
    setBookingConfirmed(true);
  };

  const handleClose = (): void => {
    if (bookingConfirmed) {
      dispatch(getApplicantOffer(applicantId, uni, offerId));
    }
    setBookingConfirmed(false);
    onClose();
  };

  return (
    <Modal
      show={isOpen}
      onClose={handleClose}
      title="Book interview"
      footer={
        <ButtonGroup spacing={3} size="lg">
          <Button onClick={handleClose}>Close</Button>
        </ButtonGroup>
      }
    >
      {schedulingUrl ? (
        <CalendlyInlineWidget url={schedulingUrl} utmContent={utmKey} onEventScheduled={handleEventScheduled} />
      ) : (
        <Box py={4}>
          <Text>The booking link is not yet configured. Please contact the admissions team.</Text>
        </Box>
      )}
    </Modal>
  );
};
